import React, { useState, useEffect, useRef } from "react";
import Textarea from "../../../../components/ui/Textarea";
import { Trash, GripVertical, Save, Loader, ChevronDown } from "lucide-react";
import {
  getBackgroundAndContextContent,
  getTeamContent,
} from "../../../../api/contentApi";

const Card = ({
  slide,
  onInputChange,
  stil,
  innerRef,
  provided,
  onDelete,
  index,
  section,
}) => {
  const textfieldRef = useRef(null);
  const [description, setDescription] = useState(slide.description);
  const [isEditing, setIsEditing] = useState(false);
  const [cardContent, setCardContent] = useState(null);
  const [loadingContent, setLoadingContent] = useState(false);

  useEffect(() => {
    if (!cardContent) {
      const fetchContent = async () => {
        setLoadingContent(true);
        if (slide.slideId === "requirementsSlide") {
          const response = await getBackgroundAndContextContent(
            slide.description
          );
          setCardContent(response.bullet_points.join(",\n\n"));
        } else if (slide.slideId === "teamSlide") {
          const response = await getTeamContent(slide.description);
          setCardContent(response.People.join(",\n\n"));
        }

        setLoadingContent(false);
      };
      fetchContent();
    }
  }, []);

  useEffect(() => {
    if (isEditing && textfieldRef.current) {
      textfieldRef.current.focus();
    }
  }, [isEditing]);

  const handleBlur = () => {
    onInputChange(description);
  };

  const handleEditCardClick = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  const handleSaveCardClick = (e) => {
    e.stopPropagation();
    setIsEditing(false);
  };

  return (
    <div className="relative flex items-start">
      <div className="flex-1">
        <div
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={stil}
          ref={innerRef}
          className="flex flex-col items-start bg-white rounded-xl relative group shadow-md p-1 pr-6 border border-slate-100 mt-5 z-10"
        >
          {/*       <div className="text-left -mt-2"> */}
          <p className="text-sm text-left p-0.5 px-3 ml-3 mt-2 inline mr-auto bg-blue-50 rounded-xl text-blue-500 font-semibold ">
            Slide {index + 1}
          </p>
          {isEditing ? (
            <div className="w-[100%] pr-6 pl-1 relative">
              <Textarea
                placeholder="Describe the slide..."
                rows="4"
                className="w-[100%] p-3 mt-3 text-slate-600 z-6 bg-white"
                value={description}
                onBlur={handleBlur}
                onChange={(e) => setDescription(e.target.value)}
                innerRef={textfieldRef}
              />
              <Save
                onClick={handleSaveCardClick}
                color="#fff"
                className="cursor-pointer bg-blue-500 p-1.5 w-7 h-7 color-white rounded-lg absolute right-8 bottom-4 z-10"
              />
            </div>
          ) : (
            <div className="flex">
              <p
                className="text-slate-600 text-md py-5 px-3.5 w-fit cursor-text text-left min-h-28"
                onClick={handleEditCardClick}
              >
                {description}
              </p>
              <Trash
                onClick={onDelete}
                className="absolute top-2 right-3 z-1 w-4 cursor-pointer hover:opacity-100 opacity-0 group-hover:opacity-60 transition-opacity duration-300"
              />
            </div>
          )}
          <GripVertical className="absolute top-[50%] translate-y-[-50%] right-0 w-6 opacity-20 cursor-move" />
        </div>
        {(cardContent || loadingContent) && (
          <div className="p-4 pt-0 group text-left relative z-20 text-slate-500 mx-2 border-t-0 shadow-lg bg-white rounded-b-xl border-slate-200 border overflow-auto  h-10 hover:h-72 transition-all duration-200 ">
            {loadingContent ? (
              <div className="flex justify-start items-center pt-3">
                <Loader
                  className={`w-5 h-5 animate-spin -mt-2.5 mr-2 text-blue-500`}
                />
                <p className="text-xs font-medium mb-3">
                  Extracting Content...
                </p>
              </div>
            ) : (
              <div className="flex justify-between w-full items-center sticky top-0 right-0 bg-white z-20 pt-3 shadow-sm">
                <p className="text-xs font-medium mb-3">Extracted Content:</p>
                <ChevronDown className="w-5 h-5 -mt-3 text-blue-400 group-hover:rotate-180 transition-transform duration-300" />
              </div>
            )}
            <p className="italic mt-2 text-sm whitespace-pre-line">
              {cardContent}
            </p>
          </div>
        )}
      </div>
      <img
        src={`slideThumbnails/${section}/s-${index + 1}.png`}
        alt="slide"
        className="min-w-48 -mr-1 w-52 rounded-lg mt-5 ml-2 border "
      />
    </div>
  );
};

export default Card;
